import { inject, Injectable } from "@angular/core";

import { AboutMenu, Category, MenuAboutType } from "@hermes/api-model-menu";
import { LOCALE, WINDOW } from "@hermes/core-app-core";
import { ANGULAR_SPA_ACTIVATION_ON_MENU_STORY_LINK } from "@hermes/hermes-web-states-flipper-state";
import { RouterService } from "@hermes/utils-generic-services-router";

import {
    isGridMenuEntry,
    isOtherMenuEntry,
    isStoryMenuEntry,
} from "../helpers/menu.helper";

@Injectable()
export class MenuUtilsService {
    private locale = inject(LOCALE);
    private window = inject<Window>(WINDOW);
    private routerService = inject(RouterService);

    public getMenuEntryPathWithoutLocale(menuEntryPath: string): string {
        return menuEntryPath.startsWith(this.locale.urlPrefix)
            ? menuEntryPath.slice(this.locale.urlPrefix.length)
            : menuEntryPath;
    }

    public navigateToMenuLink(entry: Category): void {
        if (isGridMenuEntry(entry)) {
            this.handleNavigation(entry.categoryPath);
        } else if (isStoryMenuEntry(entry)) {
            this.handleNavigation(entry.path ?? "", true);
        } else if (isOtherMenuEntry(entry)) {
            this.handleNavigation(entry.path ?? "");
        } else {
            this.window.location.assign(entry.categoryPath);
        }
    }

    public navigateToAboutMenuLink(entry: AboutMenu): void {
        if (!entry.data) {
            return;
        }

        entry.type === MenuAboutType.TYPE_INTERNAL_LINK
            ? this.routerService.spaRedirect(entry.data)
            : this.window.location.assign(entry.data);
    }

    private handleNavigation(path: string, isStory: boolean = false): void {
        if (isStory) {
            this.routerService.navigate(
                path,
                ANGULAR_SPA_ACTIVATION_ON_MENU_STORY_LINK,
            );
        } else {
            this.routerService.spaRedirect(path);
        }
    }
}
